<template>
  <div class="event-detail-status-container" v-if="Number($route.params.id)!==-99">
    <div class="status-container">
      <div v-if="!isMobile" class="placeholder" />
      <div class="status-box">
        <event-detail-status :detail="detail" v-if="Object.keys(detail).length" />
      </div>
    </div>
  </div>
</template>

<script>
import vueTypes from 'vue-types'
import { mapState } from 'vuex'
import eventDetailStatus from './event-detail-status'
export default {
  name: 'event-detail-status-sticky',
  components: {
    eventDetailStatus
  },
  props: {
    detail: vueTypes.object.def({})
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

.event-detail-status-container {
  position: sticky; bottom: 0;z-index: 10000;
  background: #fff;
  @include flexCenter;

  .status-container {
    display: flex;
    width: 1080px;
    .placeholder {
      width: 185px;
    }
    .status-box {
      flex: 1;
    }
  }
}
</style>
